import { render, staticRenderFns } from "./ArticlesCsvForm.vue?vue&type=template&id=38c4dfdd&scoped=true"
import script from "./ArticlesCsvForm.vue?vue&type=script&lang=js"
export * from "./ArticlesCsvForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c4dfdd",
  null
  
)

export default component.exports